var render = function render(){var _vm=this,_c=_vm._self._c;return _c('AccountBanksEditAdmin',{attrs:{"AB":_vm.AB,"optionsAccountBankTypes":_vm.optionsAccountBankTypes},on:{"save":function($event){return _vm.save({edit: true})}}})
}
var staticRenderFns = []

export { render, staticRenderFns }